import { useCallback, useEffect, useState } from "react";
import { SimpleHttp } from "src/lib/utils/SimpleHTTP";


export default function useGetAllSpecialties() {
  const [specialties, setSpecialties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const [retryCount, setRetry] = useState(0);

  const retry = () => {
    setRetry((prev) => ++prev);
  };

  const fetchData = useCallback(
    async () => {
      try {
        const { status, data, error } = await SimpleHttp.get(
          `/api/v1/all/getLanguages`
        );
        if (status === true) {
          setSpecialties(data);
        } else {
          console.log("Language Error:", error);
        }
      } catch (error) {
        console.log("Language Error:", error);
        setError(error);
      }
    
      setLoading(false);
    },
    [],
  )

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, [retryCount]);

  return { specialties, loading, error, retry };
}
